/**
 * Material Cache Manager type
 */
class MaterialCacheManager {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {!Map<string, !Array<!Object>>}
         */
        this.materials = new Map();
    }

    /**
     * @param {string} key
     * @return {*}
     */
    getFromCache(key) {
        return this.materials.get(key);
    }

    /**
     * @param {string} key
     * @param {*} data
     */
    setInCache(key, data) {
        this.materials.set(key, data);
    }
}

/**
 * Material Cache Manager singleton
 * @type {!MaterialCacheManager}
 */
export const materialCacheManager = new MaterialCacheManager();
